import React, {useEffect} from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    // Load all required scripts after component mount
    const loadScripts = async () => {
      // Check if jQuery is already loaded
      if (!window.jQuery) {
        await loadScript('./assets/vendor/jquery.min.js');
      }
      
      // Load other scripts in sequence to respect dependencies
      await loadScript('./assets/vendor/popper.js/popper.min.js');
      await loadScript('./assets/vendor/bootstrap/js/bootstrap.min.js');
      await loadScript('./assets/vendor/mega-menu/assets/js/custom.js');
      await loadScript('./assets/vendor/aos-next/dist/aos.js');
      await loadScript('./assets/vendor/jquery.appear.js');
      await loadScript('./assets/vendor/jquery.countTo.js');
      await loadScript('./assets/vendor/validator.js');
      await loadScript('./assets/vendor/fancybox/dist/jquery.fancybox.min.js');
      
      // Load theme JS last
      await loadScript('./assets/js/theme.js');
      
      // Initialize AOS animations
      if (window.AOS) {
        window.AOS.init({
          duration: 1000,
          once: true
        });
      }
      
      // Re-initialize any other plugins that might not be working
      if (window.theme && window.theme.init) {
        window.theme.init();
      }
    };
    
    loadScripts();
    
    // Cleanup function
    return () => {
      // If needed, add cleanup code here
    };
  }, []); // Empty dependency array means this runs once on mount
  
  return (
    <div className="theme-main-menu sticky-menu theme-menu-five">
      <div className="d-flex align-items-center justify-content-center">
        <div className="logo">
          <Link to="/">
            {/* <img src="./assets/images/logo/cybernate-logo.svg" width={180} alt="Cybernate" /> */}
              <h1 className="title" style = {{fontSize: 25, fontWeight: '500', color: '#dc3545'}}>Cybernate</h1>
          </Link>
        </div>
        <nav id="mega-menu-holder" className="navbar navbar-expand-lg">
          <div className="nav-container">
            <button className="navbar-toggler">
              <span />
            </button>
            <div
              className="navbar-collapse collapse"
              id="navbarSupportedContent"
            >
              <div className="d-lg-flex justify-content-between align-items-center">
                {isHomePage ? (
                  /* Home page navigation with hash links */
                  <ul
                    className="navbar-nav main-side-nav font-gordita"
                    id="one-page-nav"
                  >
                    <li className="nav-item">
                      <a href="#home" className="nav-link">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#features" className="nav-link">
                        Features
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#use-cases" className="nav-link">
                        Use Cases
                      </a>
                    </li>
                  </ul>
                ) : (
                  /* Other pages navigation with regular links */
                  <ul
                    className="navbar-nav main-side-nav font-gordita"
                  >
                    <li className="nav-item">
                      <Link to="/" className="nav-link">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/legal" className="nav-link">
                        Legal
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/contact" className="nav-link">
                        Contact
                      </Link>
                    </li> */}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </nav>
        {/* <div className="right-widget">
          <a
            href="#"
            data-toggle="modal"
            data-target="#contactModal"
            className="demo-button"
          >
            <span>Request A Demo</span>{" "}
            <img src="./assets/images/icon/user.svg" alt="" />
          </a>
        </div> */}

         <div className="right-widget">
          <a
            href="https://docs.cybernate.ai"
            target='_blank'
            className="demo-button"
          >
            <span>API Documentation</span>{" "}
            <img src="./assets/images/icon/55.svg" alt="" />
          </a>
        </div>


      </div>
    </div>
  );
}

// Helper function to load scripts dynamically
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

export default Header;